<div class="card border calculator">
  <div class="row">
    <h3>Price calculator</h3>
    <div class="col-md-8">
      <form [formGroup]="form">
        @if (isAccountantPricing) {
          <div class="calculator-input">
            <h5>Client registers</h5>
            <div class="range">
              <h2>
                <span class="badge bg-light text-dark">
                  {{ form.value.totalRegisters }}
                </span>
              </h2>
              <input
                formControlName="totalRegisters"
                type="range"
                class="form-range"
                id="asset-range"
                min="0"
                max="200"
                step="1"
              />
            </div>
          </div>
        }

        <div class="calculator-input">
          <h5>{{ isAccountantPricing ? 'Total assets' : 'Assets' }}</h5>
          <div class="range">
            <h2>
              <span class="badge bg-light text-dark">
                {{ form.value.totalAssets | number }}
              </span>
            </h2>
            <input
              formControlName="totalAssets"
              type="range"
              class="form-range"
              id="asset-range"
              min="0"
              max="2000"
              step="5"
            />
          </div>
        </div>
      </form>
    </div>

    <div class="col-md-4">
      <div class="price">
        <h3>{{ packageDisplayName }} plan</h3>
        <h4>Estimated price</h4>

        <div class="total">
          <h1>
            @if (pricingResult && !calculatingPrice) {
              <span class="badge text-dark">
                {{
                  pricingResult.totalPrice | aacurrency: subscription?.currency
                }}
              </span>
            }
            @if (calculatingPrice) {
              <app-loading></app-loading>
            }
          </h1>
          @if (pricingResult && !calculatingPrice) {
            <p>
              per month
              @if (subscription?.currency) {
                in {{ subscription?.currency }}
              }
            </p>
          }
        </div>

        @if (showCustom) {
          <app-alert type="info" size="small" class="w-100">
            <p>
              Based on this usage you might be better served with an annual
              plan.
            </p>
            <p>Talk to us to discuss special pricing.</p>
          </app-alert>
        }
      </div>
    </div>
  </div>
</div>
